<template>
    <prime-button
        :label="t('ok')"
        class="p-button-outlined"
        @click="emit('close')"
    />
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import { useI18n } from 'vue-i18n'

defineOptions({
    name: 'AppAlertFooter'
})

const emit = defineEmits<{
    (e: 'close'): void
}>()

const { t } = useI18n({ useScope: 'global' })
</script>
